import * as promiseRetry from 'promise-retry'

import RSVP from 'rsvp'
import Vue from 'vue'
import axios from 'axios'
import createHash from 'sha.js'
import qz from '@/../own_modules/qz-tray/qz-tray'
import variables from '@/utils/variables'

const qzTrayMixin = {
  methods: {
    initPrinterConnection () {
      qz.api.setPromiseType(function promise (resolver) {
        return new RSVP.Promise(resolver)
      })

      qz.api.setSha256Type(function (data) {
        return createHash('sha256').update(data).digest('hex')
      })

      qz.security.setCertificatePromise(function (resolve) {
        // if development environment we should get key/certificate from production environment
        // this is the domainname that has the certificate (*.vaporshop.store)
        const domain = variables.devMode ? `https://pos-1.vaporshop.store` : variables.baseUrl
        return promiseRetry((retry, number) => axios.get(`${domain}/cert.pem`).catch(retry))
          .then(data => resolve(data.data))
          .catch(err => Vue.rollbar.error(err))
        // return axios.get(`${domain}/cert.pem`)
        //   .then(data => resolve(data.data))
        //   .catch((data) => Vue.rollbar.error(data))
      })

      qz.security.setSignaturePromise(function (toSign) {
        return function (resolve) {
          // if development environment we should get key/certificate from production environment
          // this is the domainname that has the certificate (*.vaporshop.store)
          const domain = variables.devMode ? `https://pos-4.vaporshop.store` : variables.baseUrl
          return promiseRetry((retry, number) => axios.get(`${domain}/sign`, { params: { request: toSign } }).catch(retry))
            .then(data => resolve(data.data))
            .catch(err => Vue.rollbar.error(err))
          // return axios.get(`${domain}/sign`, { params: { request: toSign } })
          //   .then(data => resolve(data.data))
          //   .catch((data) => Vue.rollbar.error(data))
        }
      })

      return qz.websocket.connect({ retries: 5 })
        .then(() => Promise.resolve())
        .catch((data) => Promise.reject(data))
    },
    closePrinterConnection () {
      qz.websocket.disconnect()
    }
  }
}

export default qzTrayMixin



// WEBPACK FOOTER //
// ./src/utils/mixins/qzTrayMixin.js